export type RarityRevealPhase = 'wait' | 'hold' | 'crack' | 'flash' | 'reveal'

export type RarityRevealConfig = {
  name: string
  primary: string
  secondary: string
  tell: number
  crack: number
  flash: number
  reveal: number
  parts: number
  shards: number
  rays: number
  shake: number
}

export const RARITY_REVEAL_COMMON_WAIT = 1500

// Удержание: первые 700 мс кольцо заполняется нейтральным цветом одинаково у
// всех редкостей, дальше — хвост в цвете редкости, до 1400 мс суммарно у 5★.
export const RARITY_REVEAL_HOLD_NEUTRAL_MS = 700
export const RARITY_REVEAL_HOLD_STEP_MS = 175

export const getHoldDurationMs = (rarity: number): number => {
  const normalized = Math.min(5, Math.max(1, Math.round(rarity)))
  return RARITY_REVEAL_HOLD_NEUTRAL_MS + (normalized - 1) * RARITY_REVEAL_HOLD_STEP_MS
}

// Скорость самой анимации (crack/flash/reveal) одинакова у всех редкостей —
// ориентир легендарная (5★). Различается только визуальная интенсивность
// (цвет, частицы, осколки, лучи, тряска), а не длительность фаз.
const REVEAL_TIMING = {
  tell: 820,
  crack: 860,
  flash: 100,
  reveal: 3500,
}

export const RARITY_REVEAL: Record<1 | 2 | 3 | 4 | 5, RarityRevealConfig> = {
  1: {
    name: 'Обычная',
    primary: '#00FFE1',
    secondary: '#009CF3',
    ...REVEAL_TIMING,
    parts: 18,
    shards: 6,
    rays: 0,
    shake: 0,
  },
  2: {
    name: 'Редкая',
    primary: '#AE00FF',
    secondary: '#4D00FF',
    ...REVEAL_TIMING,
    parts: 40,
    shards: 8,
    rays: 0,
    shake: 0,
  },
  3: {
    name: 'Эпическая',
    primary: '#FF9FEB',
    secondary: '#F300BF',
    ...REVEAL_TIMING,
    parts: 90,
    shards: 10,
    rays: 10,
    shake: 3,
  },
  4: {
    name: 'Мифическая',
    primary: '#FF5C33',
    secondary: '#FF0000',
    ...REVEAL_TIMING,
    parts: 170,
    shards: 14,
    rays: 16,
    shake: 7,
  },
  5: {
    name: 'Легендарная',
    primary: '#FFF81F',
    secondary: '#FFC300',
    ...REVEAL_TIMING,
    parts: 300,
    shards: 18,
    rays: 22,
    shake: 10,
  },
}

export const getRarityRevealConfig = (rarity: number): RarityRevealConfig => {
  const normalized = Math.min(5, Math.max(1, Math.round(rarity))) as 1 | 2 | 3 | 4 | 5
  return RARITY_REVEAL[normalized]
}
